/* unplugin-vue-components disabled */import { render } from "./DashboardSpeachsTiles.vue?vue&type=template&id=7536783c&scoped=true&ts=true"
import script from "./DashboardSpeachsTiles.vue?vue&type=script&lang=ts"
export * from "./DashboardSpeachsTiles.vue?vue&type=script&lang=ts"

import "./DashboardSpeachsTiles.vue?vue&type=style&index=0&id=7536783c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7536783c"]])

export default __exports__